const getOverriddenCategories = (state: AnyFixMe) => state.addPanel.overridden;

export { getOverriddenCategories };
